import { render } from "./MapBlock.vue?vue&type=template&id=1d6a2635"
import script from "./MapBlock.vue?vue&type=script&lang=js"
export * from "./MapBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__